import { intersection } from 'lodash';
import axios from 'axios';
import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import {getBaseURL, nil} from '@/common';
import {AxiosFindAll, FeathersVuexFindAll} from '@/utils';
import routes from '@/routing/routes';
import Home from '@/components/Pages/Home Page/Home.vue';


Vue.use(Router);
const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: routes(store),
});
router.beforeEach((to, from, next) => {
  window.dataLayer = window.dataLayer || [];
  setTimeout(() => {
    if (!nil((window as any).Tawk_API)) {
      to.path.indexOf('/dashboard') > -1 ? (window as any).Tawk_API.hideWidget() : (window as any).Tawk_API.showWidget();
    }
  }, 250);
  const appbarState = to.matched.some((record) => record.meta.appbar);
  store.dispatch('ui/setAppBarVisible', appbarState);
  const bookingToolbarMode = to.matched.some(
      (record) => record.meta.toolbarMode === 1,
  );
  store.dispatch('ui/setToolbarMode', bookingToolbarMode ? 1 : 0);
  if (!nil(from.meta.popEditingService) && to.name === from.meta.popEditingService && store.state.booking.editingService > 0) {
    store.dispatch('booking/setEditingService', store.state.booking.editingService - 1);
    next(false);
  } else {
    const currentUser = store.state.auth.user;
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
    const roles = to.meta.roles;
    if ((requiresAuth || roles) && !currentUser) {
      store.dispatch('ui/setRedirectPath', to.path);
      next('/login');
    } else if (
        currentUser &&
        roles &&
        intersection(roles, currentUser.roles).length === 0
    ) {
      next(false);
    } else {
      to.name === 'Login' ? next('/') : next();
    }
  }
});
router.afterEach((to, from) => {
  window.scrollTo(0, 0);
});

export async function generateRoutes() {
  // await AxiosFindAll('page-configs');
}

export default router;
